var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 17.9296,
    height: 14,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 24.9912H24.6234C26.0851 24.9912 26.9296 24.1467 26.9296 22.474V13.5092C26.9296 11.8445 26.0769 11 24.3798 11H11.3062C9.8445 11 9 11.8364 9 13.5092V22.474C9 24.1548 9.85263 24.9912 11.5498 24.9912ZM11.501 23.7489C10.689 23.7489 10.2424 23.3185 10.2424 22.474V13.5092C10.2424 12.6728 10.689 12.2424 11.501 12.2424H24.4285C25.2243 12.2424 25.6872 12.6728 25.6872 13.5173V22.482C25.6872 23.3185 25.2243 23.7489 24.4285 23.7489H11.501ZM17.981 20.1597C18.5495 20.1597 19.1016 19.9242 19.67 19.3639L26.2637 12.8839L25.4192 12.0313L18.9636 18.4057C18.6144 18.7549 18.2977 18.9091 17.981 18.9091C17.6562 18.9091 17.3395 18.7467 16.9985 18.4057L10.5104 11.9988L9.65774 12.8514L16.292 19.3639C16.8604 19.9242 17.4045 20.1597 17.981 20.1597ZM25.338 23.9275L26.1825 23.0748L20.9287 17.886L20.0842 18.7305L25.338 23.9275ZM9.77143 23.083L10.6159 23.9356L15.8779 18.7305L15.0252 17.886L9.77143 23.083Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.4fadde66b7881c4b77a8fe9844b1037a.svg";
export { ForwardRef as ReactComponent };